import { S as SCROLL_BUFFER } from './bundle-joPrRU5E.js';
import { useRef, useEffect } from 'react';
import { usePreservedCallback } from '@sendbird/uikit-tools';
import { e as isAboutSame } from './bundle-4PBxOF7r.js';

function useThrottleCallback(callback, delay, options) {
    if (options === void 0) { options = {
        leading: true,
        trailing: false,
    }; }
    var timer = useRef(null);
    var trailingArgs = useRef(null);
    useEffect(function () {
        return function () {
            if (timer.current)
                clearTimeout(timer.current);
        };
    }, []);
    return usePreservedCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timer.current) {
            trailingArgs.current = args;
            return;
        }
        if (options.leading) {
            callback.apply(void 0, args);
        }
        else {
            trailingArgs.current = args;
        }
        var invoke = function () {
            if (options.trailing && trailingArgs.current) {
                callback.apply(void 0, trailingArgs.current);
                trailingArgs.current = null;
                timer.current = setTimeout(invoke, delay);
            }
            else {
                timer.current = null;
            }
        };
        timer.current = setTimeout(invoke, delay);
    });
}

var DELAY = 100;
function calcScrollBottom(scrollHeight, scrollTop) {
    return scrollHeight - scrollTop;
}
function useHandleOnScrollCallback(_a) {
    var hasMore = _a.hasMore, hasNext = _a.hasNext, onScroll = _a.onScroll, scrollRef = _a.scrollRef, setShowScrollDownButton = _a.setShowScrollDownButton;
    var scrollCb = usePreservedCallback(function () {
        var element = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
        if (element == null)
            return;
        var scrollTop = element.scrollTop, scrollHeight = element.scrollHeight, clientHeight = element.clientHeight;
        // https://sendbird.atlassian.net/browse/SBISSUE-11759
        // the edge case where channel is inside a page that already has scroll
        // scrollintoView will move the whole page, which we dont want
        var scrollBottom = calcScrollBottom(scrollHeight, scrollTop);
        // even if there is more to fetch or not,
        // we still have to show the scroll to bottom button
        if (typeof setShowScrollDownButton === 'function') {
            setShowScrollDownButton(scrollHeight > scrollTop + clientHeight + 1);
        }
        // Load previous messages
        // 1. check if hasMore(hasPrevious) and reached to top
        // 2. load previous messages (onScroll)
        // 3. maintain scroll position (sets the scroll position to the bottom of the new messages)
        if (hasMore && isAboutSame(scrollTop, 0, SCROLL_BUFFER)) {
            onScroll(function () {
                var messagesAreAddedToView = element.scrollHeight > scrollHeight;
                if (messagesAreAddedToView)
                    element.scrollTop = element.scrollHeight - scrollBottom;
            });
        }
        // Load next messages
        // 1. check if hasNext and reached to bottom
        // 2. load next messages (onScroll)
        // 3. maintain scroll position (sets the scroll position to the top of the new messages)
        if (hasNext && isAboutSame(clientHeight + scrollTop, scrollHeight, SCROLL_BUFFER)) {
            onScroll(function () {
                var messagesAreAddedToView = element.scrollHeight > scrollHeight;
                if (messagesAreAddedToView)
                    element.scrollTop = scrollTop;
            });
        }
    });
    return useThrottleCallback(scrollCb, DELAY, { trailing: true });
}

export { useThrottleCallback as a, useHandleOnScrollCallback as u };
//# sourceMappingURL=bundle-W0Wz_roj.js.map
